"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function GlowOrb({
  className,
  color = "accent",
  size = 320,
  delay = 0,
}: {
  className?: string;
  color?: "accent" | "cyan" | "violet";
  size?: number;
  delay?: number;
}) {
  const tones = {
    accent: "bg-accent/30",
    cyan: "bg-cyan/25",
    violet: "bg-violet/30",
  };

  return (
    <motion.div
      aria-hidden
      className={cn("pointer-events-none absolute rounded-full blur-3xl", tones[color], className)}
      style={{ width: size, height: size }}
      animate={{
        scale: [1, 1.12, 1],
        opacity: [0.45, 0.75, 0.45],
        x: [0, 18, 0],
        y: [0, -14, 0],
      }}
      transition={{ duration: 10 + delay, repeat: Infinity, ease: "easeInOut", delay }}
    />
  );
}

export function FloatingBadge({
  children,
  className,
  delay = 0,
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) {
  return (
    <motion.div
      className={cn(
        "pointer-events-none absolute z-10 rounded-full border border-white/15 bg-black/45 px-3 py-1.5 text-[10px] font-semibold tracking-[0.16em] text-white/85 backdrop-blur-md",
        className,
      )}
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay }}
    >
      {children}
    </motion.div>
  );
}